/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Rag_Title3Inputs */

const en_svc_ai_integration_rag_title3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrieval-augmented generation`)
};

const ar_svc_ai_integration_rag_title3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التوليد المعزز بالاسترجاع`)
};

const bn_svc_ai_integration_rag_title3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিট্রিভাল-অগমেন্টেড জেনারেশন`)
};

const de_svc_ai_integration_rag_title3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abruf-erweiterte Generierung`)
};

const es_svc_ai_integration_rag_title3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generación de recuperación aumentada`)
};

const fr_svc_ai_integration_rag_title3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération augmentée par récupération`)
};

const pt_svc_ai_integration_rag_title3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geração aumentada por recuperação`)
};

const zh_svc_ai_integration_rag_title3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检索增强生成`)
};

const tr_svc_ai_integration_rag_title3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almayla artırılmış nesil`)
};

const ru_svc_ai_integration_rag_title3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генерация с расширенным поиском`)
};

const pl_svc_ai_integration_rag_title3 = /** @type {(inputs: Svc_Ai_Integration_Rag_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generacja wzmocniona wyszukiwaniem`)
};

/**
* | output |
* | --- |
* | "Retrieval-augmented generation" |
*
* @param {Svc_Ai_Integration_Rag_Title3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_rag_title3 = /** @type {((inputs?: Svc_Ai_Integration_Rag_Title3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Rag_Title3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_rag_title3(inputs)
	if (locale === "bn") return bn_svc_ai_integration_rag_title3(inputs)
	if (locale === "de") return de_svc_ai_integration_rag_title3(inputs)
	if (locale === "es") return es_svc_ai_integration_rag_title3(inputs)
	if (locale === "fr") return fr_svc_ai_integration_rag_title3(inputs)
	if (locale === "pt") return pt_svc_ai_integration_rag_title3(inputs)
	if (locale === "zh") return zh_svc_ai_integration_rag_title3(inputs)
	if (locale === "tr") return tr_svc_ai_integration_rag_title3(inputs)
	if (locale === "ru") return ru_svc_ai_integration_rag_title3(inputs)
	if (locale === "pl") return pl_svc_ai_integration_rag_title3(inputs)
	return en_svc_ai_integration_rag_title3(inputs)
});
export { svc_ai_integration_rag_title3 as "svc_ai-integration_RAG_title" }